Attributes of the newly created position opening.
